export const hasNavLinks = state => {
  return state.navLinks.count > 0
}



// WEBPACK FOOTER //
// ./src/store/getters.js